import React, { useEffect, useState } from "react";
import {
  Bell,
  IdCard,
  CircleGauge,
  Wallet,
  Route,
  UserRoundPen,
  LogOut,
} from "lucide-react";
import { Link } from "react-router-dom";
import Profile from "../../assets/3d-illustration-cartoon-character-hoodie-cap.jpg";
import { useDispatch, useSelector } from "react-redux";
import { driverSelector, fetchOnedriver, logOut } from "../../api/driver";
import axios from "axios";
import { keyUri } from "../../key";
import { Navigate, useNavigate } from "react-router-dom";
import { fetchAllbooking, bookingSelector } from "../../api/bookings";
import { getAllBookings, seatBookSelector } from "../../api/seatbooking";
//import seatbooking, { getAllBookings, seatBookSelector } from "../../api/seatbooking";

export default function ProfilePage() {
  const { all_booking } = useSelector(bookingSelector);
const { getAllBooks } = useSelector(seatBookSelector);
  const { driver } = useSelector(driverSelector);
  const [user, setuser] = useState({});
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const dispatch = useDispatch()
  const { current_driver } = useSelector(driverSelector);
  console.log("driver:", current_driver);
  const driver_id_ = localStorage.getItem("driverid");

  
  const driverId = userData?._id || current_driver?._id;

useEffect(() => {
  if (driverId) {
    dispatch(fetchAllbooking(driverId));
  }
}, [dispatch, driverId]);


const now = new Date();

const pastRides = all_booking.filter(ride => {
  const rideDate = new Date(ride.ride_date_and_time || ride.rideDate);
  return String(ride.driverId?._id || ride.driverId) === String(driverId) &&
         //ride.status === "Ride Completed" &&
         rideDate < new Date();
});



console.log("Completed rides count:", pastRides?.length);

console.log("Bookings array:", all_booking);
console.log("Driver ID:", driverId);



console.log("Driver ID (filter):", driverId);
all_booking.forEach(ride => {
  console.log("Ride driverId:", ride.driverId?._id || ride.driverId);
});

all_booking.forEach(ride => {
  console.log("Ride date:", ride.ride_date_and_time, "Parsed:", new Date(ride.ride_date_and_time));
});

const completedRides = all_booking.filter(ride => ride.status === "Ride Completed");
console.log("Completed rides count by status:", completedRides.length);

const statuses = [...new Set(all_booking.map(ride => ride.status))];
console.log("Unique ride statuses:", statuses);


  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("usr roi user hoai", user?._json?.email);
        const user_phone = localStorage.getItem("phoneNumber")
          ? localStorage.getItem("phoneNumber")
          : null;
        console.log(user_phone);

        if (user_phone) {
          const response = await axios.post(
            `${keyUri.BACKEND_URI}/api/getdriverfromphone`,
            { phone: user_phone }
          );
          console.log("API response 🎈🎃🎠", response.data);
          localStorage.setItem("Driver", response.data.driver._id);
          setUserData(response?.data?.driver);
          localStorage.setItem("authToken", response.data.token);
        } else {
          console.error("phone number is not available.");
          setUserData(driver)
        }
      } catch (err) {
        console.error("Error occurred while creating driver:", err);
      }
    };

    fetchData();
  }, []);



  useEffect(() => {
    const driverid = localStorage.getItem("Driver");
    // const driver_id_ = localStorage.getItem("driverid")
    console.log("Setting otp's respective login setup", driverid);
    
    
    dispatch(fetchOnedriver(driver_id_));
    dispatch(fetchAllbooking(driver_id_));
    dispatch(getAllBookings(driver_id_));
  }, [dispatch, driver_id_]);
  console.log(driver)
  console.log(userData);
  const handleclick = async (item) => {
    if (item === "Performance") {
      console.log("Clicked Performance");
      navigate('/performance')
    } else if (item === "My UPI ID") {
      console.log("clicked My UPI ID");
      navigate('/myUPI')
    } else if (item === "TGH ID Card") {
      console.log("clicked TGH ID Card");
      navigate('/IDCard')
    } else if (item === "Documents") {
      console.log("clicked Documents");
      navigate('/driverDocuments')
    } else if (item === "Notification") {
      console.log("clicked Notification");
    } else if (item === "Log out") {
      console.log("clicked Log out");
      dispatch(logOut());
  
      
    }
  };
  console.log("here is the fkin driver",current_driver);
  
  //console.log("driver photo:", current_driver?.Driver_photo_link)
  
  return (
    <div className="max-w-md mx-auto bg-white min-h-screen mb-12 mt-36">
      <div className="bg-white px-6 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-black text-3xl font-medium">Profile</span>
        </div>
        <div className="flex">
    {(userData?._id || current_driver?._id) && (
  <Link
    to={`/edit-driver/${userData?._id || current_driver?._id}`}
    className="text-black flex items-center gap-2"
    aria-label="Edit"
  >
    <UserRoundPen className="w-5 h-5" />
    <span>Edit</span>
  </Link>
)}


        </div>
      </div>

      <div className="px-6 py-4">
        <div className="flex items-start gap-4 mb-6">
         <img
  src={userData?.Driver_photo_link ||current_driver?.Driver_photo_link || Profile}
  alt="Profile"
  className="w-16 h-16 rounded-full object-cover"
/>

          <div>
            <h2 className="text-lg font-medium">{userData?.name || current_driver?.name}</h2>
            <p className="text-sm text-gray-500 mb-1">{userData?.email || current_driver?.email}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
            <div className="flex items-center gap-2 mb-2">
              <div className="bg-[#FFF4DE] p-2 rounded-lg">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="#FFB340"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-sm text-gray-500">Balance</span>
            </div>
           <span className="text-xl font-semibold truncate">
  ₹{parseFloat(
    userData?.wallet_amount?.$numberDecimal || current_driver?.wallet_amount?.$numberDecimal || 0
  ).toFixed(2)}
</span>

          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
            <div className="flex items-center gap-2 mb-2">
              <div className="bg-gray-100 p-2 rounded-lg">
                <Route className="w-4 h-4 text-gray-600" />
              </div>
              <span className="text-sm text-gray-500">Rides</span>
            </div>
            <span className="text-xl font-semibold">{pastRides.length || 0}</span>
          </div>
        </div>

        <div className="border-b border-gray-200 pb-4 mb-6">
          <p className="text-sm font-semibold text-gray-600">
            Driving Licence Number - {userData?.Driver_licence_number}
          </p>
        </div>

        <div>
          <h3 className="text-base font-semibold mb-3">Other Details</h3>
          <div className="grid grid-cols-3 gap-4">
            {[
              { icon: <IdCard className="w-5 h-5" />, label: "TGH ID Card" },
              {
                icon: <CircleGauge className="w-5 h-5" />,
                label: "Performance",
              },
              { icon: <Wallet className="w-5 h-5" />, label: "Documents" },
              {
                icon: (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 9H13"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M7 12H13"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="12"
                      height="12"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                ),
                label: "My UPI ID",
              },
              { icon: <Bell className="w-5 h-5" />, label: "Notification" },
              { icon: <LogOut className="w-5 h-5" />, label: "Log out" },
            ].map((item, index) => (
              <button
                key={index}
                className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-xl gap-2"
                aria-label={item.label}
                onClick={() => handleclick(item.label)}
              >
                <div className="text-gray-600">{item.icon}</div>
                <span className="text-xs text-gray-600">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
